
import FinancePaymentsPerPageFilterField from './finance-payments-per-page-filter-field'
import FinancePaymentsSortFilterField from './finance-payments-sort-filter-field'
import PropTypes from 'prop-types'
import { ListGroup, ListGroupItem } from 'reactstrap'

const propTypes = {
  perPage               : PropTypes.string,
  sortBy                : PropTypes.string,
  sortDir               : PropTypes.string,
  handlePerPageOnChange : PropTypes.func,
  handleSortOnClick     : PropTypes.func
}

const defaultProps = {
  perPage               : '10',
  sortBy                : '',
  sortDir               : '',
  handlePerPageOnChange : () => { },
  handleSortOnClick     : () => {}
}

const FinancePaymentsPagingFilterField = ({
  perPage,
  sortBy,
  sortDir,
  handlePerPageOnChange,
  handleSortOnClick
}) => (
  <ListGroup className='pb-2'>
    <ListGroupItem>
      <FinancePaymentsPerPageFilterField
        perPage={ perPage }
        handlePerPageOnChange={ handlePerPageOnChange }
      />
    </ListGroupItem>

    <ListGroupItem>
      <FinancePaymentsSortFilterField
        sortBy={ sortBy }
        sortDir={ sortDir }
        handleSortOnClick={ handleSortOnClick }
      />
    </ListGroupItem>
  </ListGroup>
)

FinancePaymentsPagingFilterField.propTypes    = propTypes
FinancePaymentsPagingFilterField.defaultProps = defaultProps

export default FinancePaymentsPagingFilterField
